import React, { useContext } from 'react';
import HeroSection from './HeroSection';
// import Issues from '../reports/issues/Issues';
import Reviews from '../reviews/Reviews';
import ContactUsSection from '../contact/ContactUsSection';
import HowItWorks from './HowItWorks';
import ReviewSection from '../reviews/ReviewSection';
// import { ReportContext } from '../reports/ReportContext';
// import HomeStats from '../stats/HomeStats';

export default function Home() {
  // const {getDeviceId,addNewUnloggedReport} = useContext(ReportContext)
  // const id = getDeviceId()
  return (
    <div className=''>
      <HeroSection />
      {/* <HomeStats /> */}
      <HowItWorks />
      {/* <AboutSection />
      <FeaturesSection /> */}
      {/* <HowItWorks /> */}
      {/* <Issues /> */}
      {/* <EventTimelineSection /> */}
      {/* <Reviews /> */}
      <ReviewSection/>
      <ContactUsSection/>
    </div>
  );
}
